/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 16:20:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { NULL } from 'src/tools/constant';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { fetchContentContentPage, fetchInitContentContentPage } from '../slice';
import { useCloneBtnParams } from 'src/hooks/useCloneBtnParams';

const CloneBtn = () => {
  const params: any = useParams();

  const _d = useDispatch();
  const _params = useCloneBtnParams();

  const handleOnClick = () => {
    const { contentUuid, contentPageUuid } = params;
    if (contentPageUuid !== NULL) {
      _d(
        fetchContentContentPage({
          uuid: contentPageUuid,
          params: _params,
          isClone: true,
        }),
      );
    } else {
      _d(
        fetchInitContentContentPage({
          uuid: contentUuid,
          params: {
            [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]:
              true,
          },
        }),
      );
    }
  };
  return <Button onClick={handleOnClick} />;
};
export default CloneBtn;
